import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Dialog, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { WarningAmber as WarningIcon } from '@mui/icons-material';
import { constants } from '../constants';
const ConfirmationDialog = ({ isOpen, setIsOpen, bodyText, submitFunction, submitButtonText, loading, actionType = 'delete' }) => {
    // Define colors based on action type
    const getActionColors = () => {
        switch (actionType) {
            case 'save':
            case 'discard':
                return {
                    iconColor: '#26890D', // Green
                    iconBgColor: '#e8f5e8',
                    submitBgColor: '#26890D',
                    submitBorderColor: '#26890D'
                };
            case 'delete':
            default:
                return {
                    iconColor: '#da291c', // Red from Figma design
                    iconBgColor: '#fdeaea',
                    submitBgColor: '#da291c',
                    submitBorderColor: '#da291c'
                };
        }
    };
    const colors = getActionColors();
    return (_jsxs(Dialog, { open: isOpen, onClose: () => setIsOpen(false), maxWidth: "xs", fullWidth: true, "data-testid": "confirmation-dialog", sx: {
            '& .MuiDialog-paper': {
                borderRadius: '8px',
                boxShadow: '0px 0px 2px 0px rgba(0,0,0,0.12), 0px 4px 8px 0px rgba(0,0,0,0.14)',
                padding: 0,
                backgroundColor: '#ffffff'
            }
        }, children: [_jsx(DialogContent, { sx: { px: 2, py: 3, textAlign: 'center' }, children: _jsxs(Box, { sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: 2
                    }, children: [_jsx(Box, { sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 72,
                                height: 72,
                                borderRadius: '50%',
                                backgroundColor: colors.iconBgColor,
                                border: `2px solid ${colors.iconColor}`
                            }, children: _jsx(WarningIcon, { sx: {
                                    color: colors.iconColor,
                                    fontSize: 32
                                } }) }), _jsx(Box, { sx: { px: 2 }, children: _jsx(Typography, { variant: "h6", color: "#212121", fontWeight: 600, children: bodyText }) })] }) }), _jsxs(DialogActions, { sx: {
                    px: 3,
                    py: 2,
                    gap: 2,
                    justifyContent: 'center'
                }, children: [_jsx(Button, { onClick: () => setIsOpen(false), variant: "outlined", disabled: loading, sx: {
                            minHeight: '40px',
                            borderRadius: '2px',
                            textTransform: 'none',
                            fontFamily: 'Open Sans',
                            fontSize: '16px',
                            fontWeight: 400,
                            px: 1.5,
                            py: 1,
                            borderColor: colors.submitBorderColor,
                            color: colors.submitBgColor,
                            letterSpacing: '0.15px',
                            lineHeight: 1.52,
                            flex: 1,
                            '&:hover': {
                                borderColor: colors.submitBorderColor,
                                backgroundColor: 'rgba(218, 41, 28, 0.04)'
                            }
                        }, children: constants.cancel }), _jsx(Button, { onClick: submitFunction, variant: "contained", disabled: loading, sx: {
                            minHeight: '40px',
                            borderRadius: '2px',
                            textTransform: 'none',
                            fontFamily: 'Open Sans',
                            fontSize: '16px',
                            fontWeight: 400,
                            px: 1.5,
                            py: 1,
                            backgroundColor: colors.submitBgColor,
                            color: '#ffffff',
                            letterSpacing: '0.15px',
                            lineHeight: 1.52,
                            flex: 1,
                            boxShadow: 'none',
                            '&:hover': {
                                backgroundColor: actionType === 'delete' ? '#b71c1c' : '#1e7b0d',
                                boxShadow: 'none'
                            },
                            '&:disabled': {
                                backgroundColor: '#e0e0e0',
                                color: '#999'
                            }
                        }, children: loading ? constants.processing : submitButtonText })] })] }));
};
export { ConfirmationDialog };
